import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/svg/search.svg?url";
const SvgSearch = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#99A1BD",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-search",
  ...props
}, /* @__PURE__ */ React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 8
}), /* @__PURE__ */ React.createElement("line", {
  x1: 21,
  y1: 21,
  x2: 16.65,
  y2: 16.65
}));
export {SvgSearch as ReactComponent};
export default svgUrl;
